import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <address className="copyright">&copy; {(new Date).getFullYear()} Linky PTY LTD</address>
    </footer>
  );
}
